import * as React from "react";
import { DogCompetitionResultSearch, DogResultsApi, DogTitlesApi, SaveNewDogTitleDto } from "../../../../../../api";
import { FGCustomPanel, IDataTableColumn } from "nsitools-react";
import { ETLCodes } from "../../../../../../locales";
import { useApiService, useTl } from "../../../../../../hooks";
import { SmallFormGenerator, SRSHCustomSelector } from "../../../../../../components";

export interface IDogTitlesSelectorProps {
  onSaved: () => void;
  title: SaveNewDogTitleDto;
  dogId: number;
}

export const DogTitlesSelector: React.FunctionComponent<IDogTitlesSelectorProps> = ({ onSaved, title, dogId }) => {
  const { t } = useTl();
  const resultApi = useApiService(DogResultsApi);
  const titleApi = useApiService(DogTitlesApi);

  const columns = React.useMemo<IDataTableColumn[]>(
    () => [
      {
        header: () => t(ETLCodes.Competition),
        fieldName: "competition",
      },
      {
        header: () => t(ETLCodes.Result),
        fieldName: "result",
      },
    ],
    [t]
  );

  const initialData = React.useMemo(() => title, [title]);

  const getResults = React.useCallback(
    (sObj: any) => resultApi.baseSearch(DogCompetitionResultSearch.fromJS({ ...sObj, dogId: dogId })),
    [dogId, resultApi]
  );
  const getResultIds = React.useCallback(
    (sObj: any) => resultApi.getIds(DogCompetitionResultSearch.fromJS({ ...sObj, dogId: dogId })),
    [dogId, resultApi]
  );

  const saveItem = React.useCallback(
    async (res) => {
      initialData.resultIds = res.resultIds;
      await titleApi.saveNewDogTitle(initialData).then(() => onSaved());
    },
    [initialData, onSaved, titleApi]
  );

  return (
    <SmallFormGenerator
      initialValues={initialData}
      onSubmit={saveItem}
      editMode={true}
      loading={false}
      saving={false}
      onCancel={onSaved}
    >
      <FGCustomPanel>
        {(ctx) => (
          <SRSHCustomSelector
            linkedIds={ctx.formik.values.resultIds}
            columns={columns}
            onLinkedIdsChanged={(newIds) => ctx.formik.setFieldValue("resultIds", newIds)}
            idField="competitionResultId"
            searchFunction={getResults}
            searchIdsFunc={getResultIds}
            editMode={true}
          />
        )}
      </FGCustomPanel>
    </SmallFormGenerator>

    // <SRSHSelector
    //   languageId={currentLanguage.languageId}
    //   linkedIds={initialData.resultIds}
    //   columns={columns}
    //   idField="competitionResultId"
    //   tlDataPrefix="CompetitionResultSearchCriterias"
    //   searchIdsFunc={getResultIds}
    //   getCriteriasFunction={() => resultApi.getSearchCriterias(true)}
    //   searchFunction={getResults}
    //   dialogContext={dialogContext}
    //   sortKeys={{ competition: "ASC" }}
    //   onSave={async (newIds) => {
    //     initialData.resultIds = newIds;
    //     await titleApi.saveNewDogTitle(initialData).then(() => onSaved());
    //   }}
    //   onCancel={() => onSaved()}
    //   editMode={true}
    // />
  );
};
